module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "fm"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#fm_R",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ROM")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ESK")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OPHIE")]), _vm._v(" C"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ASS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Dateline-Chapter-dl"
  }), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Dateline-ldl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("New York")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Dateline-ldl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("August 28, 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Salutation-lsa"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dear Mr. Lambert,")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Body-Text-ltx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Here’s the thing. You can ignore my letters if you wish, but my piece will run in")]), _vm._v(" The New York Times"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" whether you, or your lawyers, like it or not. If it weren’t for our family connection, I’d sue you in a heartbeat. I don’t like threats. I am a professional investigative journalist, Mr. Lambert, and I’m just doing my job. This is not some personal vendetta as you claim, nor have I used underhand tactics. As an artist, I’m sure you appreciate the key is to look, to listen clearly, and see the things that other people miss. I looked, and I saw the truth—plain and simple.")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Body-Text-ltx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("My sources are rock solid, and more importantly I have new evidence for my claims. You see, I have discovered photographs, Mr. Lambert, taken by Alistair Quimby in 1940, the summer before you met Varian Fry in Marseille. Not only are there stunning photos of my great-aunt Vita, there are photos of you at work in the studio at the Château d’Oc. Both of you. I assume I don’t need to explain any more?")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Body-Text-ltx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Your lawyers have done their damnedest to warn me off, but now I am warning you—this piece celebrating your illustrious career and 95th birthday will run. I’m going to give you one last chance to put your side of the story before I file my copy. I will come and see you after Labor Day, at midday on Thursday, September 7. I imagine now you’ll be ready to talk.")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Closing-lcl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Yours,")])]), _vm._v(" "), _c('p', {
    staticClass: "Letter-Ext-Closing-lcl"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sophie Cass")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16eacb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 72
// module chunks = 0